import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {NzIconModule} from 'ng-zorro-antd/icon';
import {NzInputModule} from 'ng-zorro-antd/input';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {AIInputComponent} from 'app/common/ai-input/ai-input.component';
import {NzTooltipModule} from 'ng-zorro-antd/tooltip';
import {FormsModule} from '@angular/forms';
import {ReactiveFormsModule} from '@angular/forms';
import {SatPopoverModule} from '@ncstate/sat-popover';
import {NzEmptyModule} from 'ng-zorro-antd/empty';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzTabsModule} from 'ng-zorro-antd/tabs';
import {DiEntityLibsModule} from 'app/common/di-entity-libs/di-entity-libs.module';
import {DiFormsModule} from 'app/common/di-forms/di-forms.module';
import {SpeechmaticsModelService} from 'app/blocks/service/speech/speechmatics-model.service';
import {DefaultSpeechModelService} from 'app/blocks/service/speech/default-speech-model.service';

@NgModule({
    declarations: [AIInputComponent],
    imports: [
        CommonModule,
        TranslateModule,
        NzIconModule,
        NzInputModule,
        FontAwesomeModule,
        NzTooltipModule,
        FormsModule,
        ReactiveFormsModule,
        SatPopoverModule,
        NzEmptyModule,
        NzFormModule,
        FontAwesomeModule,
        NzTabsModule,
        DiEntityLibsModule,
        DiFormsModule
    ],
    exports: [AIInputComponent],
    providers: [SpeechmaticsModelService, DefaultSpeechModelService]
})
export class AIInputModule {}
